import React from "react";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps, labels }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "2rem", width: "100%", maxWidth: "500px" }}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <React.Fragment key={i}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
            <div
              style={{
                width: "100%",
                height: "4px",
                borderRadius: "2px",
                backgroundColor: i <= currentStep ? "#000" : "#e0e0e0",
                transition: "background-color 0.3s ease",
              }}
            />
            <span
              style={{
                fontSize: "0.7rem",
                color: i === currentStep ? "#000" : "#999",
                marginTop: "4px",
                fontWeight: i === currentStep ? 600 : 400,
              }}
            >
              {labels[i]}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressBar;
